module.exports = __webpack_public_path__ + "img/图层 73.05e2d012.png";